import { useCallback, useEffect, useState } from 'react';
import { AudioCompanionOption } from '@Components/CreativeAllocation';
import { useSetError } from '../../redux/modals';
import { FlashtalkingLambdaFetch, awaitJSON } from '../fetch-utils';
import { useCompanyInfo } from './useCompanyInfo';

// Fetches the Flashtalking audio-companion banners available for the current company.
export const useAudioCompanionOptions = (): AudioCompanionOption[] => {
  const { cid: company } = useCompanyInfo();
  const setError = useSetError();
  const [audioCompanionOptions, setAudioCompanionOptions] = useState<AudioCompanionOption[]>([]);

  const fetchAudioCompanions = useCallback(async () => {
    const companionOptions: AudioCompanionOption[] = [];
    try {
      const res = await FlashtalkingLambdaFetch('/fetchStoredFlashtalkingAudioCompanions', {
        params: { company }
      });
      const companionMap =
        await awaitJSON<Record<string, { companion_placement_name: string }>>(res);
      if (companionMap) {
        // The ID for audio companions in flashtalking is the placement ID.
        for (const placementID of Object.keys(companionMap)) {
          const row = companionMap[placementID];
          companionOptions.push({
            adid: placementID,
            assetid: placementID,
            title: row.companion_placement_name
          });
        }
      }
    } catch (e) {
      setError({
        message: `Couldn't fetch flashtalking audio companion options. ${e.message}`,
        reportError: e
      });
    } finally {
      setAudioCompanionOptions(companionOptions);
    }
  }, [company, setError]);

  useEffect(() => {
    if (company) {
      fetchAudioCompanions();
    }
  }, [company, fetchAudioCompanions]);

  return audioCompanionOptions;
};
